import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Select from '../../../components/ui/Select';

const BulkActions = ({ selectedShifts, onSelectAll, onDeselectAll, onBulkAction }) => {
  const [bulkActionType, setBulkActionType] = useState('');

  const bulkActionOptions = [
    { value: '', label: 'Aktion wählen...' },
    { value: 'export', label: 'Exportieren' },
    { value: 'request-swap', label: 'Tausch beantragen' },
    { value: 'update-availability', label: 'Verfügbarkeit aktualisieren' },
    { value: 'add-notes', label: 'Notizen hinzufügen' }
  ];

  const handleBulkAction = () => {
    if (bulkActionType && selectedShifts?.length > 0) {
      onBulkAction(bulkActionType, selectedShifts);
      setBulkActionType('');
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-card mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <Checkbox
              checked={selectedShifts?.length > 0}
              indeterminate={selectedShifts?.length > 0 && selectedShifts?.length < 15}
              onChange={(e) => e?.target?.checked ? onSelectAll() : onDeselectAll()}
            />
            <span className="text-sm text-foreground">
              {selectedShifts?.length > 0 
                ? `${selectedShifts?.length} Schicht${selectedShifts?.length > 1 ? 'en' : ''} ausgewählt`
                : 'Alle auswählen'
              }
            </span>
          </div>

          {selectedShifts?.length > 0 && (
            <div className="flex items-center space-x-2">
              <Select
                options={bulkActionOptions}
                value={bulkActionType}
                onChange={setBulkActionType}
                className="min-w-48"
              />
              <Button
                variant="default"
                size="sm"
                iconName="Play"
                iconPosition="left"
                iconSize={14}
                onClick={handleBulkAction}
                disabled={!bulkActionType}
              >
                Ausführen
              </Button>
            </div>
          )}
        </div>

        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            iconSize={14}
            onClick={() => onBulkAction('export-all', [])}
          >
            Alle exportieren
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="RefreshCw"
            iconPosition="left"
            iconSize={14}
            onClick={() => window.location?.reload()}
          >
            Aktualisieren
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;